// Carry Roll CompareScreen — Screen 2. Comparison table | dispersion map.
// Uses calc-nav TabGroup to switch between table and map views with URL hash
// persistence (#compare/table, #compare/dispersion).

import { TabGroup } from 'calc-nav';
import type { TabDef } from 'calc-nav';
import { Collapsible } from '../components/calculator/Collapsible';
import { ScenarioSet } from '../components/compare/ScenarioSet';
import { ComparisonTable } from '../components/compare/ComparisonTable';
import { DispersionMap } from '../components/compare/DispersionMap';
import { FairwayHitProbability } from '../components/compare/FairwayHitProbability';

export default function CompareScreen() {
  const tabs: TabDef[] = [
    { id: 'table', label: 'Table', content: <ComparisonTable /> },
    {
      id: 'dispersion',
      label: 'Dispersion Map',
      content: (
        <div className="flex flex-col gap-4">
          <FairwayHitProbability />
          <DispersionMap />
        </div>
      ),
    },
  ];

  return (
    <div className="measure flex flex-col gap-4" data-testid="compare-screen">
      <h2 className="section-title">
        Compare
      </h2>
      <Collapsible title="Scenario set" testId="compare-scenario-set">
        <ScenarioSet />
      </Collapsible>
      <TabGroup section="compare" tabs={tabs} ariaLabel="Comparison views" />
    </div>
  );
}
